<template>
    <div>
        <SortableList title="Menus"
            ref="organizer"
            @add="() => showMenuCatalog = true"
            @selected="(item) => $emit('selected', item.id)"
            @fetchedValues="(list) => menus = list"
            :saveOrderPromise="saveOrder"
            :busy.sync="busy"/>

        <a-modal v-model="showMenuCatalog" title="Menus"
            :dialog-style="{ top: '20px' }"
            :width="700" :zIndex="9999999"
            :footer="null">
            
            <MenuCatalog @add="addMenu" 
                :existentMenus="menus"/>

        </a-modal>
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'

    import SortableList from './SortableList';
    import MenuCatalog from '../menu/MenuCatalog.vue'

    import organizerMixin from './organizerMixin';

    export default {
        mixins: [organizerMixin('menu')],
        components: {
            SortableList,
            MenuCatalog
        },
        data() {
            return {
                showMenuCatalog: false,
                menus: [],
            }
        },
        methods: {
            async addMenu (menu) {
                this.busy = true;
                try {
                    let companyId = this.$store.getters.getCompanyID ;
                    const fb = firebase.firestore();
                    const batch = fb.batch();
                    // Creates new menu
                    const menuRef = firebase.firestore().collection(`/company/${companyId}/menu`).doc(menu.id);
                    batch.set(menuRef, {
                        description: menu.description,
                        icon: `mdi-${menu.icon}`,
                        order: this.menus.length
                    });
                    // Adds default Product Type to menu
                    const productTypeRef = firebase.firestore().collection(`/company/${companyId}/productType`).doc();
                    batch.set(productTypeRef, {
                        id: productTypeRef.id,
                        description: menu.description,
                        menu: menuRef.id,
                        order: 0,
                        products: {},
                        active: true,
                    });

                    await batch.commit();

                } catch (err) {
                    this.$store.commit('setError', err);
                } finally {
                    this.showMenuCatalog = false;
                    this.busy = false;
                }
            },
        },
        async mounted () {
            await this.get(); // inside mixin
        },
    }
</script>

<style lang="scss" scoped>

</style>